import { useState, useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';

const ROLES = {
  ADMIN: 'ADMIN',
  DATA_MANAGER: 'DATA_MANAGER',
  LOGISTICS_COORDINATOR: 'LOGISTICS_COORDINATOR',
  AREA_COORDINATOR: 'AREA_COORDINATOR',
  CLIENT: 'CLIENT',
};

const PERMISSIONS = {
  CREATE_PRODUCT: 'product_add',
  EDIT_PRODUCT: 'product_change',
  DELETE_PRODUCT: 'product_delete',
  VIEW_PRODUCT: 'product_view'
};

const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: [
    PERMISSIONS.CREATE_PRODUCT,
    PERMISSIONS.EDIT_PRODUCT,
    PERMISSIONS.DELETE_PRODUCT,
    PERMISSIONS.VIEW_PRODUCT
  ],
  [ROLES.DATA_MANAGER]: [
    PERMISSIONS.CREATE_PRODUCT,
    PERMISSIONS.EDIT_PRODUCT,
    PERMISSIONS.DELETE_PRODUCT,
    PERMISSIONS.VIEW_PRODUCT
  ],
  [ROLES.LOGISTICS_COORDINATOR]: [
    PERMISSIONS.EDIT_PRODUCT,
    PERMISSIONS.VIEW_PRODUCT
  ],
  [ROLES.AREA_COORDINATOR]: [
    PERMISSIONS.EDIT_PRODUCT,
    PERMISSIONS.VIEW_PRODUCT
  ],
  [ROLES.CLIENT]: [
    PERMISSIONS.VIEW_PRODUCT
  ]
};

const usePermissions = () => {
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const hasPermission = (permission) => {
    if (!user?.role?.name) return false;
    return ROLE_PERMISSIONS[user.role.name]?.includes(permission) || false;
  };

  const can = {
    createProduct: () => hasPermission(PERMISSIONS.CREATE_PRODUCT),
    editProduct: () => hasPermission(PERMISSIONS.EDIT_PRODUCT),
    deleteProduct: () => hasPermission(PERMISSIONS.DELETE_PRODUCT),
    viewProduct: () => hasPermission(PERMISSIONS.VIEW_PRODUCT)
  };

  return {
    loading,
    error,
    can,
    ROLES,
    PERMISSIONS
  };
};

export default usePermissions;
